module.exports = __webpack_public_path__ + "img/shape.3d281f59.svg";